import React from 'react';
import PropTypes from 'prop-types';

import { PAYMENT_ACCOUNT_CARD, PAYMENT_ACCOUNT_BANK_ACCOUNT } from 'common/paymentAccountConstants';

import SrIcon from 'client/components/SrIcon';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrBankAccountCard.less';

const SrBankAccountCard = ({ bankAccount, onChangeClick }) => {
  return (
    <div styleName="container">
      <SrIcon
        className={
          bankAccount.type === PAYMENT_ACCOUNT_CARD
            ? 'payment-account-type-card-yellow'
            : 'payment-account-type-bank-yellow'
        }
      />
      <SrBox marginLeft="12px">
        <SrText font="wsc" fontSize="12px" letterSpacing="1px" weight="600">
          {bankAccount.type === PAYMENT_ACCOUNT_CARD && 'CARD'}
          {bankAccount.type === PAYMENT_ACCOUNT_BANK_ACCOUNT && 'BANK'}
        </SrText>
        <SrText font="wsc" fontSize="16px" weight="500" color="grey">
          {` •••• ${bankAccount.cardLast4 || bankAccount.bankAccountLast4} `}
        </SrText>
      </SrBox>
      {onChangeClick && (
        <div styleName="flex1">
          <SrText
            display="block"
            align="right"
            width="100%"
            weight="600"
            color="blue300"
            cursor="pointer"
            onClick={onChangeClick}
          >
            Change
          </SrText>
        </div>
      )}
    </div>
  );
};

SrBankAccountCard.propTypes = {
  bankAccount: PropTypes.object.isRequired,
  onChangeClick: PropTypes.func,
};

SrBankAccountCard.displayName = 'SrBankAccountCard';

export default SrBankAccountCard;
